import React from 'react';
import { useSearchState } from '../../hooks/useSearchState';
import type { Filter } from '@elastic/search-ui';
import posthog from 'posthog-js';

const HOMOLOGATION_OPTIONS = [
  { type: 'porsche_cup', label: 'Porsche Cup' },
  { type: 'fia', label: 'FIA' },
  { type: 'aco', label: 'ACO' },
  { type: 'unknown', label: 'Other' },
];

export const HomologationFacet: React.FC = () => {
  const { currentState, driver } = useSearchState();

  // Check if a homologation type is currently filtered
  const isHomologationSelected = (type: string) => {
    if (!currentState?.filters) return false;

    return currentState.filters.some(
      (filter: Filter) =>
        (filter.field === 'listing_porsche_cup' &&
          type === 'porsche_cup' &&
          filter.values.includes('yes')) ||
        (filter.field === 'listing_fia' &&
          type === 'fia' &&
          filter.values.includes('yes')) ||
        (filter.field === 'listing_aco' &&
          type === 'aco' &&
          filter.values.includes('yes')) ||
        (filter.field === 'listing_porsche_cup' &&
          type === 'unknown' &&
          filter.values.includes('unknown')) ||
        (filter.field === 'listing_fia' &&
          type === 'unknown' &&
          filter.values.includes('unknown')) ||
        (filter.field === 'listing_aco' &&
          type === 'unknown' &&
          filter.values.includes('unknown'))
    );
  };

  const handleHomologationToggle = (type: string) => {
    const isCurrentlySelected = isHomologationSelected(type);

    if (isCurrentlySelected) {
      // Remove the homologation filters
      if (type === 'porsche_cup') {
        driver.removeFilter('listing_porsche_cup', 'yes');
      } else if (type === 'fia') {
        driver.removeFilter('listing_fia', 'yes');
      } else if (type === 'aco') {
        driver.removeFilter('listing_aco', 'yes');
      } else if (type === 'unknown') {
        driver.removeFilter('listing_porsche_cup', 'unknown');
        driver.removeFilter('listing_fia', 'unknown');
        driver.removeFilter('listing_aco', 'unknown');
      }
    } else {
      // Add the homologation filters
      if (type === 'porsche_cup') {
        driver.addFilter('listing_porsche_cup', 'yes', 'any');
      } else if (type === 'fia') {
        driver.addFilter('listing_fia', 'yes', 'any');
      } else if (type === 'aco') {
        driver.addFilter('listing_aco', 'yes', 'any');
      } else if (type === 'unknown') {
        driver.addFilter('listing_porsche_cup', 'unknown', 'any');
        driver.addFilter('listing_fia', 'unknown', 'any');
        driver.addFilter('listing_aco', 'unknown', 'any');
      }
    }

    posthog.capture('homologation_filter_applied', {
      type: type,
      action: isCurrentlySelected ? 'removed' : 'added',
    });
  };

  return (
    <div className="flex items-center flex-wrap gap-4 pt-1 pb-1">
      <div className="flex items-center flex-wrap gap-4">
        {HOMOLOGATION_OPTIONS.map((option) => {
          const isSelected = isHomologationSelected(option.type);
          return (
            <button
              key={option.type}
              onClick={() => handleHomologationToggle(option.type)}
              className={`font-mono text-xs transition-colors ${
                isSelected
                  ? 'text-mp-text'
                  : 'text-mp-muted/40 hover:text-mp-muted'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
